export enum UserRole {
	Default = 0,
	TradeManager = 1,
	BackOffice = 2,
	Trader = 3,
	ReadOnly = 4,
}
